import React from "react";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import { Box, Typography, CircularProgress, useTheme } from "@mui/material";

const PageLoader = ({ text = "Loading..." }) => {
	const theme = useTheme(); // Access the current theme

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "100vh",
			}}
		>
			<CircularProgress
				sx={{
					color: theme.palette.primary.main,
					mb: 2,
				}}
				size={60}
				thickness={4.5}
			/>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					gap: 1,
				}}
			>
				<HourglassBottomIcon
					sx={{
						fontSize: 30,
						color: theme.palette.text.secondary,
					}}
				/>
				<Typography
					variant="h6"
					sx={{
						color: theme.palette.text.primary,
						fontWeight: "bold",
					}}
				>
					{text}
				</Typography>
			</Box>
		</Box>
	);
};

export default PageLoader;
